// extracted by mini-css-extract-plugin
export default {"absPosition":"Popup_absPosition__-laXe","popupWindow":"Popup_popupWindow__OmCW8"};